<script>
  import LL from "$i18n/i18n-svelte";
</script>

{$LL.share.URL_COPIED()}
